import Moment from 'moment';
import { dateFormats } from '../../common/constants/dateFormats';

/**
 * Formats incoming date string in C# API Date format.
 *
 * @param dateTime
 * @return {string}
 */
export const formatDateTimeForAPI = (dateTime) => {
  return Moment(dateTime).format(dateFormats.API_DATE_TIME_FORMAT);
};

/**
 * Formats incoming date string as UI Display date, e.g, Mon, Dec 12, 1997 at 3:30 PM
 *
 * @param dateTime
 * @return {string}
 */
export const formatDateForRDATDisplay = (dateTime) => {
  return Moment(dateTime).format(
    dateFormats.DAY_MONTH_DAY_AND_TIME_DISPLAY_FORMAT
  );
};

/**
 * Formats incoming date string as twelve hour time, e.g., 8:30 PM
 *
 * @param dateTime
 * @return {string}
 */
export const formatTime = (dateTime) => {
  return Moment(dateTime, dateFormats.API_DATE_TIME_FORMAT).format(
    dateFormats.SHORT_TWELVE_HOUR_TIME_FORMAT
  );
};

/**
 * Formats in single hour time format.
 *
 * @param time
 * @return {string}
 */
export const formatTwelveHourTime = (time) =>
  Moment(time, 'HH:mm').format('h:mm');

/**
 * Formats in a 24-hour time with no leading zeros into a twelve hour time with no leading zeros.
 *
 * @param time
 * @return {string}
 */
export const formatZeroTwelveHourTime = (time) =>
  Moment(time, 'H:mm').format('h:mm');
/**
 * Formats API Date into Twenty Four hour time.
 *
 * @param date
 * @return {string}
 */
export const formatTwentyFourHourTime = (date) =>
  Moment(date, dateFormats.API_DATE_TIME_FORMAT).format(
    dateFormats.TWENTY_FOUR_HOUR_TIME
  );
/**
 * Entering a date in input field like `3/21` without year sets the date's year to 0001.
 * So we require dates to at least be within the last decade.
 *
 * @param date Moment date.
 * return bool
 */
export const dateYearIsReasonable = (date) => {
  return date.isAfter(Moment().subtract(10, 'year'));
};

/**
 * Formats a date object with date and fieldId properties.
 *
 * @param dateObj
 * return object DateTime
 */
export const prepareFormattedDateTimeObject = (dateObj) => {
  const data = {};
  const DateTime = dateObj.date ? formatDateTimeForAPI(dateObj.date) : '';
  const FieldId = dateObj.fieldId;
  Object.assign(data, { DateTime }, { FieldId });

  return data;
};

export const ONE_DAY = { value: 1, unit: 'days' };
export const THREE_HOURS = { value: 3, unit: 'hours' };



// WEBPACK FOOTER //
// ./src/common/lib/DateFormatting.js